const getters = {
  menuList: state => state.common.menuList,
  token: state => state.user.token
}

export default getters
